import { cn } from "@/lib/utils";
import { t } from "@shared/i18n";

export function passwordScore(pw: string) {
  let score = 0;
  if (pw.length >= 10) score++;
  if (pw.length >= 14) score++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) score++;
  if (/\d/.test(pw)) score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;
  if (/^(.)\1+$/.test(pw) || /password|motdepasse|azerty|qwerty|123456/i.test(pw)) score = Math.min(score, 1);
  return Math.min(score, 4);
}

const LABELS = [t("Très faible"), t("Faible"), t("Moyen"), t("Solide"), t("Excellent")];
const COLORS = ["bg-accent", "bg-accent", "bg-warning", "bg-success", "bg-success"];

export function PasswordStrength({ password }: { password: string }) {
  if (!password) return null;
  const score = passwordScore(password);
  return (
    <div className="space-y-1" aria-live="polite">
      <div className="flex gap-1">
        {[0, 1, 2, 3].map((i) => (
          <span key={i} className={cn("h-1 flex-1 rounded-full", i < Math.max(score, 1) ? COLORS[score] : "bg-border")} />
        ))}
      </div>
      <p className="text-[12px] text-muted">
        {t("Robustesse :")} <span className="font-medium text-fg">{LABELS[score]}</span>
        {password.length < 10 && t(" — 10 caractères minimum")}
      </p>
    </div>
  );
}
